import _ from 'lodash'
export class SearchDataModel {
  id = null
  name = ''
  parameter = {
    age: { minimum: 18, maximum: 65 },
    gender: null,
    address: {
      prefectures: [],
      /** 選択オプション
        * null： 現住所か希望勤務地いずれか合致
        * present : 現住所のみ
        * desired : 希望勤務地のみ
        */
      selectedOption: null,
      /** 希望勤務地こだわらない・未設定ユーザー返却フラグ
        * true : 「希望勤務地未登録」を含める（空のユーザーも返却する）
        * デフォルト：含めないためfalse
        */
      containNonHopeUser: false
    },
    educationalBackground: null,
    changeOverJobsCount: { maximum: null },
    employed: null,
    annualSalary: { minimum: null, maximum: null },
    desiredSalary: { minimum: null, maximum: null },
    graduatedSchool: { keywords: [], operator: 'and', year: { from: null, to: null } },
    occupations: {
      experienced: [],
      desired: [],
      containNonHopeUser: false,
      operator: 'or'
    },
    businesses: {
      experienced: [],
      desired: [],
      containNonHopeUser: false,
      operator: 'or'
    },
    hasCareerResumes: false,
    targetBehavior: 1,
    activeRecent: null,
    toeicScore: { minimum: null },
    toeflScore: { minimum: null },
    englishSkill: { minimum: null },
    changeJobsMotivations: [],
    companyStyle: null,
    searchingWorkPrefectures: [],
    searchingOccupations: [],
    searchingBusinesses: [],
    registrationDate: {
      selectedDateTimeWithinDays: null,
      selectedDateTimeRangeForm: null
    },
    resumeUpdateDate: {
      selectedDateTimeWithinDays: null,
      selectedDateTimeRangeForm: null
    },
    userId: null,
    freeWord: { keywords: [], operator: 'and' },
    excludeWord: { keywords: [], operator: 'or' },
    activeDate: {
      from: '',
      to: ''
    },
    skills: {
      conditions: [],
      operator: 'and'
    },
    licenses: {
      ids: [],
      operator: 'and'
    },
    excludeEntryOtherCompanyJob: false,
    excludeCasualInterviewEntryOtherCompanyJob: false,
    excludedCandidateOtherJob: false,
    excludedApproachedScout: {
      otherCompany: {
        maximum: null
      },
      ownCompany: {
        thisJob: {
          selectedDateTimeWithinDays: null,
          selectedDateTimeRangeForm: null
        },
        otherJob: {
          selectedDateTimeWithinDays: null,
          selectedDateTimeRangeForm: null
        }
      }
    },
    excludedApproachedLiked: {
      selectedDateTimeWithinDays: null,
      selectedDateTimeRangeForm: null
    }
  }

  condition = {
    graduatedSchoolKeyword: '',
    selectedRegistrationDateValue: {},
    registrationDate_from: '',
    registrationDate_to: '',
    selectedResumeUpdateDateValue: {},
    resumeUpdateDate_from: '',
    resumeUpdateDate_to: '',
    freeWord: '',
    excludeWord: '',
    selectedApproachedThisJobOptionValue: {},
    approachedThisJob_from: '',
    approachedThisJob_to: '',
    selectedApproachedOtherJobOptionValue: {},
    approachedOtherJob_from: '',
    approachedOtherJob_to: '',
    selectedLikedOptionValue: {},
    liked_from: '',
    liked_to: ''
  }

  constructor (searchData) {
    if (searchData) {
      this.id = _.get(searchData, 'id', null)
      this.name = _.toString(_.get(searchData, 'name'))
      const parameter = searchData.parameter
      this.parameter.age.minimum = _.get(parameter, 'age.minimum', 18)
      this.parameter.age.maximum = _.get(parameter, 'age.maximum', 65)
      this.parameter.gender = _.get(parameter, 'gender', null)
      this.parameter.educationalBackground = _.get(parameter, 'educationalBackground', null)
      this.parameter.changeOverJobsCount.maximum = _.get(parameter, 'changeOverJobsCount.maximum', null)
      this.parameter.employed = _.get(parameter, 'employed', null)
      this.parameter.annualSalary.minimum = _.get(parameter, 'annualSalary.minimum', null)
      this.parameter.annualSalary.maximum = _.get(parameter, 'annualSalary.maximum', null)
      this.parameter.desiredSalary.minimum = _.get(parameter, 'desiredSalary.minimum', null)
      this.parameter.desiredSalary.maximum = _.get(parameter, 'desiredSalary.maximum', null)
      this.parameter.graduatedSchool.keywords = _.toArray(_.get(parameter, 'graduatedSchool.keywords'))
      this.parameter.graduatedSchool.operator = _.toString(_.get(parameter, 'graduatedSchool.operator', 'and'))
      this.parameter.graduatedSchool.year.from = _.get(parameter, 'graduatedSchool.year.from', null)
      this.parameter.graduatedSchool.year.to = _.get(parameter, 'graduatedSchool.year.to', null)
      this.parameter.address.prefectures = _.toArray(_.get(parameter, 'address.prefectures'))
      this.parameter.address.selectedOption = _.get(parameter, 'address.selectedOption', null)
      this.parameter.address.containNonHopeUser = !!_.get(parameter, 'address.containNonHopeUser')
      this.parameter.occupations.experienced = _.toArray(_.get(parameter, 'occupations.experienced'))
      // 希望職種はモーダルで表現する場合に[{id: 1}]の形でないと復元できないため
      this.parameter.occupations.desired = _.toArray(_.get(parameter, 'occupations.desired', []).map(desiredOccupation => {
        return _.has(desiredOccupation, 'id') ? desiredOccupation : { id: desiredOccupation }
      }))
      this.parameter.occupations.operator = _.toString(_.get(parameter, 'occupations.operator', 'or'))
      this.parameter.occupations.containNonHopeUser = !!_.get(parameter, 'occupations.containNonHopeUser')
      this.parameter.businesses.experienced = _.toArray(_.get(parameter, 'businesses.experienced'))
      this.parameter.businesses.desired = _.toArray(_.get(parameter, 'businesses.desired'))
      this.parameter.businesses.operator = _.toString(_.get(parameter, 'businesses.operator', 'or'))
      this.parameter.businesses.containNonHopeUser = !!_.get(parameter, 'businesses.containNonHopeUser')
      this.parameter.hasCareerResumes = !!_.get(parameter, 'hasCareerResumes')
      this.parameter.targetBehavior = _.get(parameter, 'targetBehavior', 1)
      this.parameter.activeRecent = _.get(parameter, 'activeRecent', null)
      this.parameter.toeicScore.minimum = _.get(parameter, 'toeicScore.minimum', null)
      this.parameter.toeflScore.minimum = _.get(parameter, 'toeflScore.minimum', null)
      this.parameter.englishSkill.minimum = _.get(parameter, 'englishSkill.minimum', null)
      this.parameter.changeJobsMotivations = _.toArray(_.get(parameter, 'changeJobsMotivations'))
      this.parameter.companyStyle = _.get(parameter, 'companyStyle', null)
      this.parameter.searchingWorkPrefectures = _.toArray(_.get(parameter, 'searchingWorkPrefectures'))
      this.parameter.searchingOccupations = _.toArray(_.get(parameter, 'searchingOccupations'))
      this.parameter.searchingBusinesses = _.toArray(_.get(parameter, 'searchingBusinesses'))
      // 最終ログインの復元
      this.parameter.registrationDate.selectedDateTimeWithinDays = _.get(parameter, 'registrationDate.selectedDateTimeWithinDays', null)
      if (_.has(parameter, 'registrationDate.selectedDateTimeRangeForm.from')) {
        _.set(this.parameter.registrationDate, 'selectedDateTimeRangeForm.from', _.toString(_.get(parameter, 'registrationDate.selectedDateTimeRangeForm.from')))
      }
      if (_.has(parameter, 'registrationDate.selectedDateTimeRangeForm.to')) {
        _.set(this.parameter.registrationDate, 'selectedDateTimeRangeForm.to', _.toString(_.get(parameter, 'registrationDate.selectedDateTimeRangeForm.to')))
      }
      // レジュメ更新日の復元
      this.parameter.resumeUpdateDate.selectedDateTimeWithinDays = _.get(parameter, 'resumeUpdateDate.selectedDateTimeWithinDays', null)
      if (_.has(parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.from')) {
        _.set(this.parameter.resumeUpdateDate, 'selectedDateTimeRangeForm.from', _.toString(_.get(parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.from')))
      }
      if (_.has(parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.to')) {
        _.set(this.parameter.resumeUpdateDate, 'selectedDateTimeRangeForm.to', _.toString(_.get(parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.to')))
      }
      this.parameter.userId = _.get(parameter, 'userId', null)
      this.parameter.freeWord.keywords = _.toArray(_.get(parameter, 'freeWord.keywords'))
      this.parameter.freeWord.operator = _.toString(_.get(parameter, 'freeWord.operator', 'and'))
      this.parameter.excludeWord.keywords = _.toArray(_.get(parameter, 'excludeWord.keywords'))
      this.parameter.activeDate.from = _.toString(_.get(parameter, 'activeDate.from'))
      this.parameter.activeDate.to = _.toString(_.get(parameter, 'activeDate.to'))
      this.parameter.skills.conditions = _.toArray(_.get(parameter, 'skills.conditions'))
      this.parameter.skills.operator = _.toString(_.get(parameter, 'skills.operator', 'and'))
      this.parameter.licenses.ids = _.toArray(_.get(parameter, 'licenses.ids'))
      this.parameter.licenses.operator = _.toString(_.get(parameter, 'licenses.operator', 'and'))
      this.parameter.excludeEntryOtherCompanyJob = !!_.get(parameter, 'excludeEntryOtherCompanyJob')
      this.parameter.excludeCasualInterviewEntryOtherCompanyJob = !!_.get(parameter, 'excludeCasualInterviewEntryOtherCompanyJob')
      this.parameter.excludedCandidateOtherJob = !!_.get(parameter, 'excludedCandidateOtherJob')
      this.parameter.excludedApproachedScout.otherCompany.maximum = _.get(parameter, 'excludedApproachedScout.otherCompany.maximum', null)
      this.parameter.excludedApproachedScout.ownCompany.thisJob.selectedDateTimeWithinDays = _.get(parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeWithinDays', null)
      if (_.has(parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.from')) {
        _.set(this.parameter.excludedApproachedScout.ownCompany.thisJob, 'selectedDateTimeRangeForm.from', _.toString(_.get(parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.from')))
      }
      if (_.has(parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.to')) {
        _.set(this.parameter.excludedApproachedScout.ownCompany.thisJob, 'selectedDateTimeRangeForm.to', _.toString(_.get(parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.to')))
      }
      this.parameter.excludedApproachedScout.ownCompany.otherJob.selectedDateTimeWithinDays = _.get(parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeWithinDays', null)
      if (_.has(parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.from')) {
        _.set(this.parameter.excludedApproachedScout.ownCompany.otherJob, 'selectedDateTimeRangeForm.from', _.toString(_.get(parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.from')))
      }
      if (_.has(parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.to')) {
        _.set(this.parameter.excludedApproachedScout.ownCompany.otherJob, 'selectedDateTimeRangeForm.to', _.toString(_.get(parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.to')))
      }
      this.parameter.excludedApproachedLiked.selectedDateTimeWithinDays = _.get(parameter, 'excludedApproachedLiked.selectedDateTimeWithinDays', null)
      if (_.has(parameter, 'excludedApproachedLiked.selectedDateTimeRangeForm.from')) {
        _.set(this.parameter.excludedApproachedLiked, 'selectedDateTimeRangeForm.from', _.toString(_.get(parameter, 'excludedApproachedLiked.selectedDateTimeRangeForm.from')))
      }
      if (_.has(parameter, 'excludedApproachedLiked.selectedDateTimeRangeForm.to')) {
        _.set(this.parameter.excludedApproachedLiked, 'selectedDateTimeRangeForm.to', _.toString(_.get(parameter, 'excludedApproachedLiked.selectedDateTimeRangeForm.to')))
      }
      const condition = searchData.condition // TODO データ移行方法次第で、uki同様createDefaultConditionを追加する
      this.condition.graduatedSchoolKeyword = _.toString(_.get(condition, 'graduatedSchoolKeyword'))
      this.condition.selectedRegistrationDateValue = _.defaultTo(_.get(condition, 'selectedRegistrationDateValue'), {})
      this.condition.registrationDate_from = _.toString(_.get(condition, 'registrationDate_from'))
      this.condition.registrationDate_to = _.toString(_.get(condition, 'registrationDate_to'))
      this.condition.freeWord = _.toString(_.get(condition, 'freeWord'))
      this.condition.selectedResumeUpdateDateValue = _.defaultTo(_.get(condition, 'selectedResumeUpdateDateValue'), {})
      this.condition.resumeUpdateDate_from = _.toString(_.get(condition, 'resumeUpdateDate_from'))
      this.condition.resumeUpdateDate_to = _.toString(_.get(condition, 'resumeUpdateDate_to'))
      this.condition.excludeWord = _.toString(_.get(condition, 'excludeWord'))
      this.condition.selectedApproachedThisJobOptionValue = _.defaultTo(_.get(condition, 'selectedApproachedThisJobOptionValue'), {})
      this.condition.approachedThisJob_from = _.get(condition, 'approachedThisJob_from', '')
      this.condition.approachedThisJob_to = _.get(condition, 'approachedThisJob_to', '')
      this.condition.selectedApproachedOtherJobOptionValue = _.defaultTo(_.get(condition, 'selectedApproachedOtherJobOptionValue'), {})
      this.condition.approachedOtherJob_from = _.get(condition, 'approachedOtherJob_from', '')
      this.condition.approachedOtherJob_to = _.get(condition, 'approachedOtherJob_to', '')
      this.condition.selectedLikedOptionValue = _.defaultTo(_.get(condition, 'selectedLikedOptionValue'), {})
      this.condition.liked_from = _.get(condition, 'liked_from', '')
      this.condition.liked_to = _.get(condition, 'liked_to', '')
    }
  }
}
